import { ApiService } from '~/shared/api'
import { restGetList } from '~/shared/utils/decorators'
import type { ServiceRestGetList } from '~/shared/interfaces'
import { AgreementsDocumentModel } from '~/model/Agreements'
import { toModels } from '~/shared/api/utils'
import type { AgreementsDocumentsListParams } from '~/interfaces/Agreements'

// eslint-disable-next-line
interface AgreementsDocumentsService extends ServiceRestGetList<AgreementsDocumentsListParams> {}

@restGetList
// eslint-disable-next-line no-redeclare
class AgreementsDocumentsService extends ApiService {
  protected route: string = 'agreements/documents'

  getListModel(params: AgreementsDocumentsListParams = {}): Promise<Array<AgreementsDocumentModel>> {
    return this.getList(params).then(toModels(AgreementsDocumentModel))
  }

  getActualDocuments(): Promise<Array<AgreementsDocumentModel>> {
    return this.getListModel({ include: 'versions,versions.file', 'page[size]': 50 })
  }
}

export default AgreementsDocumentsService
